import { Component, DestroyRef, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CloseComponent } from '@app/shared/components/close/close.component';
import { TranslatePipe } from '@ngx-translate/core';
import { debounceTime, tap } from 'rxjs/operators';
import { TemplateGroupsCRUDModalStore } from '../template-groups-crud-modal.store';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'topo-template-group-crud-input',
  imports: [TranslatePipe, ReactiveFormsModule, CloseComponent, MatTooltipModule],
  templateUrl: './template-group-crud-input.component.html',
  styleUrl: './template-group-crud-input.component.scss'
})
export class TemplateGroupCRUDInputComponent implements OnInit {
  protected destroyRef = inject(DestroyRef);
  control: FormControl;

  initialValue = input<string>('');
  // passing in state reference here instead of injecting because
  // the store relies on being disposed from parent component context that provides injection token
  state = input.required<TemplateGroupsCRUDModalStore>();

  hasValidInput = signal<boolean>(false);

  onSubmit = output<string>();
  valueChanged = output<string>();
  onClear = output<void>();

  disableInput$ = effect(() => {
    const isWorking = this.state()?.isWorking();

    if (isWorking && this.control?.enabled) {
      this.control.disable();
    } else if (!isWorking && this.control?.disabled) {
      this.control.enable();
    }
  });

  ngOnInit(): void {
    this.control = new FormControl(this.initialValue(), { validators: [Validators.minLength(1)] });

    this.control.valueChanges
      .pipe(
        tap(() => this.hasValidInput.set(false)),
        debounceTime(150),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(value => {
        this.valueChanged.emit(value);
        const isValid = this.state()?.checkIfNameIsUnique(value) ?? false;
        this.hasValidInput.set(isValid);
      });
  }

  onCheckClicked(value: string): void {
    this.onSubmit.emit(value);
    this.control.setValue('');
    this.control.updateValueAndValidity();
  }

  clearInput(): void {
    this.control.setValue('');
    this.control.updateValueAndValidity();
    this.onClear.emit();
  }
}
